import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

export const MarkdownLink = ({ ...props }) => {
  const { href } = props;

  let link, target;
  if (href?.includes?.('_target_')) {
    [link, target] = href.split('_target_');
  } else {
    link = href;
    target = 'blank';
  }

  return React.createElement(`a`, {
    className: clsx(styles.a),
    ...props,
    target: `_${target}`,
    href: link,
  });
};
